import { createFileRoute } from "@tanstack/react-router";
import { EditProfileForm } from "@/features/profile/components/EditProfileForm";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";

export const Route = createFileRoute("/profile/edit/")({
  component: EditProfilePage,
});

function EditProfilePage() {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow">
        <EditProfileForm />
      </main>
      <Footer />
    </div>
  );
}
